import { render, staticRenderFns } from "./AttendanceSampleCreate.vue?vue&type=template&id=0473d93e&scoped=true"
import script from "./AttendanceSampleCreate.vue?vue&type=script&lang=js"
export * from "./AttendanceSampleCreate.vue?vue&type=script&lang=js"
import style0 from "./AttendanceSampleCreate.vue?vue&type=style&index=0&id=0473d93e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0473d93e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0473d93e')) {
      api.createRecord('0473d93e', component.options)
    } else {
      api.reload('0473d93e', component.options)
    }
    module.hot.accept("./AttendanceSampleCreate.vue?vue&type=template&id=0473d93e&scoped=true", function () {
      api.rerender('0473d93e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/AttendanceSampleCreate.vue"
export default component.exports